exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".viewport[data-v-754c8752]{position:relative}.viewport canvas[data-v-754c8752],.viewport video[data-v-754c8752]{width:95vw;height:80vw;position:absolute;left:0;top:0}", ""]);

// exports
